import React, {useEffect, useMemo, useState} from 'react';
import CustomTable from '../../AlertTableDesignedWithCheckboxes';
import {APP_ALERT_CENTER_API_ENDPOINT} from 'constants/api_urls';
import '../../index.scss';
import DmpIcons from "components/DmpIcons/icons";

const CampaignListTable = ({ idaccount, jwtToken, onCampaignSelect, rowSelection, setRowSelection, onClose }) => {
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(true);

    const columns = useMemo(() => [
        { accessorKey: 'id', header: 'ID', maxSize: 40 },
        { accessorKey: 'name', header: 'Name', maxSize: 220 },
        { accessorKey: 'type', header: 'Type', maxSize: 40 },
        { accessorKey: 'hotel', header: 'Hotel', maxSize: 40 },
        {
            accessorKey: 'status',
            header: 'Status',
            maxSize: 40,
            Cell: ({ value }) => {
                if (!value) return '';
                return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
            }
        },

    ], []);

    useEffect(() => {
        const fetchCampaigns = async () => {
            try {
                const response = await fetch(`${APP_ALERT_CENTER_API_ENDPOINT}/api/alert-center/list-google-search-ads-campaign/${idaccount}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${jwtToken}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error('Erreur lors de la récupération des données');
                }

                const data = await response.json();
                setCampaigns(data);
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        };

        fetchCampaigns();
    }, [idaccount, jwtToken]);

    useEffect(() => {
        const selectedCampaigns = campaigns.filter(campaign => rowSelection[campaign.id]);
        onCampaignSelect(selectedCampaigns);
    }, [rowSelection, campaigns, onCampaignSelect]);

    return (
        <div className="hotel-table-container">
            <br />
            <div className="alert-table-hotels-title">
                <div
                    onClick={onClose}
                    className="close-panel-circle"
                >
                    <DmpIcons.ActionsIcons.ClosePanelFillColorIcon className="close-panel-icon" />
                </div>
                <h2 style={{
                    fontSize: '20px',
                    textAlign: 'left',
                    fontWeight: 400,
                    fontFamily: 'Quincy CF, serif',
                }}>
                    Select campaigns
                </h2>
            </div>
            <CustomTable
                columns={columns}
                data={campaigns}
                loading={loading}
                selectedRows={rowSelection}
                setSelectedRows={setRowSelection}
                uniqueId="id"
            />
        </div>
    );
};

export default CampaignListTable;
